import type { ServicePeriodListItem } from "./financialShared.types";
import { ServicePeriodStatus } from "./financialShared.types";

const SERVICE_PERIODS: ServicePeriodListItem[] = [
	{
		id: "period-oct-dec-25",
		propertyId: "prop-oo-mandarina",
		periodLabel: "Oct 25, 2025 – Dec 25, 2025",
		dueDate: "Jan 10, 2026",
		paidUnitsLabel: "28/32",
		status: ServicePeriodStatus.PUBLISHED,
		createdDate: "Jan 12, 2026",
		lastUpdatedBy: "Sarah Johnson",
		lastUpdatedDate: "Feb 10, 2026",
		approver: "Sarah Johnson",
		uploadedAtLabel: "Uploaded Feb 10, 2026 by Sarah Johnson",
	},
	{
		id: "period-jan-mar-26",
		propertyId: "prop-oo-mandarina",
		periodLabel: "Jan 15, 2026 – Mar 15, 2026",
		dueDate: "Mar 20, 2026",
		paidUnitsLabel: "16/32",
		status: ServicePeriodStatus.COMPLETED,
		createdDate: "Jan 20, 2026",
		lastUpdatedBy: "Michael Chen",
		lastUpdatedDate: "Feb 8, 2026",
		approver: "Michael Chen",
		uploadedAtLabel: "Uploaded Feb 8, 2026 by Michael Chen",
	},
	{
		id: "period-apr-jun-26",
		propertyId: "prop-oo-mandarina",
		periodLabel: "Apr 1, 2026 – Jun 1, 2026",
		dueDate: "Jun 15, 2026",
		paidUnitsLabel: "5/6",
		status: ServicePeriodStatus.PUBLISHED,
		createdDate: "Feb 1, 2026",
		lastUpdatedBy: "Sarah Johnson",
		lastUpdatedDate: "Feb 5, 2026",
		approver: "Sarah Johnson",
		uploadedAtLabel: "Uploaded Feb 5, 2026 by Sarah Johnson",
	},
	{
		id: "period-q4-25",
		propertyId: "prop-siro-boka",
		periodLabel: "Oct 1, 2025 – Dec 31, 2025",
		dueDate: "Jan 15, 2026",
		paidUnitsLabel: "30/32",
		status: ServicePeriodStatus.COMPLETED,
		createdDate: "Jan 5, 2026",
		lastUpdatedBy: "Michael Chen",
		lastUpdatedDate: "Feb 1, 2026",
		approver: "Michael Chen",
		uploadedAtLabel: "Uploaded Feb 1, 2026 by Michael Chen",
	},
];

export function getServicePeriodsByProperty(
	propertyId: string,
): ServicePeriodListItem[] {
	return SERVICE_PERIODS.filter((period) => period.propertyId === propertyId);
}

export function getServicePeriodById(
	periodId: string,
): ServicePeriodListItem | undefined {
	return SERVICE_PERIODS.find((period) => period.id === periodId);
}
